var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTotalRedemptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.23 17.4c-.94-.916-2.363-2.324-4.27-4.223-.594-.578-.606-1.528-.028-2.12.23-.237.532-.39.859-.438l7.507-1.091 3.357-6.803c.367-.742 1.266-1.047 2.009-.68.296.145.535.385.681.68l3.357 6.803 7.507 1.09c.82.12 1.388.881 1.269 1.7-.048.327-.201.629-.438.86L31.708 17.4",
    transform: "translate(-593 -215) translate(593 215)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23 39.5l-7.94 4.174c-.88.463-1.968.124-2.43-.755-.185-.35-.248-.752-.181-1.142l1.516-8.841h0l-6.423-6.262c-.712-.693-.727-1.833-.033-2.545.276-.283.638-.468 1.03-.525l8.877-1.29h0l3.97-8.043c.44-.892 1.52-1.258 2.41-.818.356.175.643.463.818.818l3.97 8.043h0l8.877 1.29c.984.143 1.665 1.057 1.522 2.04-.057.392-.241.754-.525 1.03l-6.423 6.262h0l1.516 8.84c.168.98-.49 1.91-1.47 2.079-.39.067-.79.003-1.141-.18L23 39.5h0z",
    transform: "translate(-593 -215) translate(593 215)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalRedemptions);
export default __webpack_public_path__ + "static/media/icon-total-redemptions.3aee9bbd.svg";
export { ForwardRef as ReactComponent };